<template>
	<div class="flex flex-col rounded-lg bg-gray-100 px-3 py-3">
		<div class="flex items-center gap-1 text-xl font-bold text-gray-700">
			{{ user?.name }}
			<ion-badge
				v-if="user instanceof GVAUserPrivilegedDTO && user.admin"
				>{{ $t("user-modal.admin") }}</ion-badge
			>
		</div>
		<template v-if="user instanceof GVAUserPrivilegedDTO">
			<div class="text-sm font-bold text-gray-500">
				{{ user?.userName }}
			</div>
			<div class="text-sm font-bold text-gray-400">
				{{ $t("user-modal.date-joined") }}
				{{
					user?.createdOnUtc?.toLocaleDateString(
						undefined,
						ShortDateFormat,
					)
				}}
			</div>
		</template>
		<TextChip
			v-if="isManagedAccount"
			title="Managed Account"
			class="mt-1 w-fit bg-gray-400 text-white"
		/>
		<UserRolesList :user="user" />
	</div>
</template>

<script setup lang="ts">
	import { IonBadge } from "@ionic/vue";
	import {
		GVAUserDTO,
		GVAUserPrivilegedDTO,
	} from "seedgreen-shared/dtos/GVAUserDTO";
	import { ShortDateFormat } from "@/utils/locale";
	import UserRolesList from "@/components/feature/user/role/UserRoleDisplayList.vue";
	import { computed } from "vue";
	import TextChip from "@/components/ui/TextChip.vue";

	const props = defineProps<{
		user: GVAUserDTO | GVAUserPrivilegedDTO | undefined;
	}>();

	const isManagedAccount = computed(() => {
		if (props.user instanceof GVAUserPrivilegedDTO) {
			return !props.user.email;
		}
		return false; // We can't tell
	});
</script>
